import {Injectable, inject} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StorageService} from '../../../../projects/vendors/src/lib/services/storage.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  private storageService = inject(StorageService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    try {
      const activeTenant = this.storageService.getFromSessionStorage('tenantId');
      if (activeTenant) {
        const clonedReq = req.clone({
          setHeaders: {
            'X-Active-Tenant': activeTenant
          }
        });
        return next.handle(clonedReq);
      }
    } catch (error) {
      this.storageService.removeFromSessionStorage('tenantId');
    }

    return next.handle(req);
  }
}

